import { render, staticRenderFns } from "./orderApplication.vue?vue&type=template&id=2eda972f&scoped=true"
import script from "./orderApplication.vue?vue&type=script&lang=js"
export * from "./orderApplication.vue?vue&type=script&lang=js"
import style0 from "./orderApplication.vue?vue&type=style&index=0&id=2eda972f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eda972f",
  null
  
)

export default component.exports